import * as React from "react";
import ParametroTopo from "./topo";
import { ParceiroAgregadoDetalhe } from "./detalhe";
import { ParceiroAgregadoBottom } from "./bottom";
import Utils from "../../helper/utils";

export const ParceiroAgregadoPage = () => {
  Utils.setDocumentTitle("Parceiro Agregado");

  return (
    <React.Fragment>
      <ParceiroAgregadoDetalhe />
      <ParceiroAgregadoBottom />
    </React.Fragment>
  );
};

export default ParceiroAgregadoPage;